import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { DateTime } from "luxon";
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const DateSelector = ({ value, onChange }) => {
  // Convert a string date (YYYY-MM-DD) to a JavaScript Date object
  const parseDate = (val) => {
    if (!val) return null;
    return DateTime.fromFormat(val, "yyyy-MM-dd").toJSDate();
  };

  const [date, setDate] = useState(parseDate(value));

  useEffect(() => {
    setDate(parseDate(value));
  }, [value]);

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);

    // Convert the selected Date to "YYYY-MM-DD" string format
    const formattedDate = selectedDate ? DateTime.fromJSDate(selectedDate).toFormat("yyyy-MM-dd") : null;
    onChange(formattedDate);
  };

  return (
    <Box>
      <DatePicker
        format="MM/dd/yyyy"
        value={date}
        style={{ width: "150px" }}
        onChange={handleDateChange}
        cleanable
      />
    </Box>
  );
};

export default DateSelector;
